import type { ProductAsset } from '../types';
import { checkScene7VideoExists } from './checkScene7VideoExists';
import { getProductAssets } from './getProductAssets';

export type ProductVariantAssetDictionary = Record<number, ProductAsset[]>;

export const getProductVariantsAssets = async (
    productIds: string[] | number[],
    masterProductID?: number
): Promise<ProductVariantAssetDictionary> => {
    const hasVideo =
        !!masterProductID && (await checkScene7VideoExists(masterProductID));

    // Create an array of promises for each product ID
    const assetPromises = productIds.map(id =>
        getProductAssets(id, masterProductID, hasVideo)
    );

    const assetsResults = await Promise.all(assetPromises);

    const productsAssetsDictionary: ProductVariantAssetDictionary = {};
    productIds.forEach((id, index) => {
        productsAssetsDictionary[id as keyof ProductVariantAssetDictionary] =
            assetsResults[index];
    });

    return productsAssetsDictionary;
};
